<template>
  <div class="talk-lobby">
    <p class="talk_head">共有&nbsp;<span>9</span>&nbsp;个洽谈位&nbsp;请选择连线咨询</p>
    <div class="service_wrap">
      <van-tabs v-model="active" class="service_list" @click="serviceClick">
        <van-tab v-for="(item,index) in serviceList" :key="index" :name="item.id" >
          <template #title>
            <div class="service_item">
              <img :src="item.img" >
              <p class="van-ellipsis">{{item.id}}</p>
              <span class="van-ellipsis">华东区总监</span>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </div>
    <div class="service_card">
      <img class="card_img" :src="cardImg" >
      <div class="touch_like">
        <div class="touch_wrap">
          <div v-for="(item,index) in serviceList.slice(0,5)" :key="index">
            <img v-if="true" :src="item.img"  >
            <img v-else src="@/assets/img/empty.png"  >
          </div>
          <p>898人联系过我</p>
        </div>
        <div class="like">
          靠谱336<i class="iconfont icon-dianzan"></i>
        </div>
      </div>
      <div class="card_btn">
        <div class="share" @click="share">
          <p>分享</p>
          <i class="iconfont icon-fenxiang"></i>
          <div class="icon_ban"></div>
        </div>
        <div class="btn video">视频连线</div>
        <div class="btn consult">在线咨询</div>
      </div>
    </div>
    <div class="service_comp">
      <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3483534024,40664929&fm=15&gp=0.jpg" >
      <div class="comp_info">
        <div class="copm_top">
          <p>成都盛林风行商贸有限公司</p>
          <span>去逛逛<i class="iconfont icon-xiala"></i></span>
        </div>
        <p class="confirm_jion">已确认参加：<span>第42届CCBE成都美博会 </span></p>
        <div class="site_tag">
          <p><i class="iconfont icon-dizhi"></i>2号馆-2D17</p>
          <p><i class="iconfont icon-biaoqian1"></i>自行车整车,自行车,自行车整</p>
        </div>
        <div class="total">
          <div>共<span>5</span>个展品</div>
          <div>共<span>3</span>个活动</div>
        </div>
      </div>
    </div>
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import liveShare from "@/components/live-share/index";  //分享
export default {
  name: "talk-lobby",
  components:{
    liveShare
  },
  data() {
    return {
      active:'11',
      cardImg:'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=1545547599,1514653233&fm=26&gp=0.jpg',
      serviceList:[
        {
          id:'11',
          img:'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3483534024,40664929&fm=15&gp=0.jpg',
        },
        {
          id:'22',
          img:'https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3972404405,1156163348&fm=15&gp=0.jpg',
        },
        {
          id:'33',
          img:'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3196508655,335078770&fm=26&gp=0.jpg',
        },
        {
          id:'44',
          img:'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1736854151,4045970539&fm=26&gp=0.jpg',
        },
        {
          id:'55',
          img:'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2358340201,3513108021&fm=26&gp=0.jpg',
        },
        {
          id:'66',
          img:'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1658567253,3647624870&fm=15&gp=0.jpg',
        }
      ],
      shareV:{},
      isShareV:true,
    } 
  },
  created(){
    this.getShareData();
  },
  mounted(){
  },
  computed: {
    ...mapGetters({
    }),
  },
  methods:{
    ...mapActions({ 
   
    }),
    serviceClick(e){
      console.log(e)
    },
    async getShareVal(){
      // let res = await this.getShareConfig(this.exhibitorId);
      if(res&&res){
        this.shareV=JSON.parse(res);
      }
      this.isShareV=true;
    },
    //分享点击
    async share(){
      if(!this.isShareV){
        // await this.getShareVal();
      }
      let addr='上海奔腾企业有限公司';
      let opt={
        title:'给你推荐一位专业客服',
        bannerTitle:'王涛', //公司名字
        subhead:addr,
        bannerUrl:this.cardImg,
      }
      this.$nextTick(()=>{
        this.$refs['liveShare'].open(opt);
      })
      await true
    },
    //分享标题，内容，图片
    async getShareData(data){
      // await this.getShareVal();
      let shareData={
        title:'给您推荐一家专业客服',
        desc:'简介',
        imgUrl:this.cardImg
      }
      this.$nextTick(()=>{
        this.$refs.liveShare.shareTo(shareData);
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.talk-lobby{
  background: #f2f2f2;
  min-height: 100vh;
  .talk_head{
    padding: 0.3rem;
    font-size: 0.26rem;
    color:#666;
    span{
      color: #333;
    }
  }
  .service_wrap{
    padding-left:0.3rem;
    width:100%;
    height: 2.46rem;
    .service_list{
      width: 100%;
      height: 100%;
      ::v-deep .van-tabs__wrap{
        width: 100%;
        height: 100%;
        .van-tabs__nav{
          width: 100%;
          height: 100%;
          overflow-x: auto;
          // display: flex;
          flex-shrink: 0;
          background: #f2f2f2;
          padding-bottom: 0;
          .van-tabs__line{
            display: none;
          }
          .van-tab{
            flex-shrink: 0;
            flex:inherit;
            flex-basis: inherit!important;
            height: 100%;
            width: 2rem;
            margin-right: 0.2rem;
            box-sizing: border-box;
            line-height: inherit;
            padding: 0 0.2rem 0 0;
            &.van-tab--active{
              .service_item{
                border-style: solid;
                border-width: 0.03rem;
                border-image-source: linear-gradient(90deg, 
                  #f3a97f 0%, 
                  #ffd0b0 100%);
                  border-image-slice: 1;
              }
            }
            .service_item{
              padding:0.32rem 0.1rem 0.3rem 0.1rem;
              background: #fff;
              border-radius: 0.05rem;
              border:0.03rem solid #fff;
              height: 100%;
              width:100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content:space-between;
              background: #fff;
              border-radius: 0.05rem;
              img{
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                // object-fit: cover;
              }
              p{
                max-width: 100%;
                font-size: 0.26rem;
                margin-top: 0.01rem;
                color: #333;
              }
              span{
                max-width: 100%;
                font-size: 0.22rem;
                color:#4d4d4d;
              }
            }
          }
        }
      }
      
      ::v-deep .van-tabs__content{
        display: none;
      }
    }
    
  }
  .service_card{
    margin-top: 0.3rem;
    width: 100%;
    padding: 0.36rem 0.3rem 0.4rem;
    background: #fff;
    .card_img{
      width: 100%;
      height: 3.94rem;
      border-radius: 0.2rem;
      // object-fit: cover;
      box-shadow: 0px 5px 10px 0px rgba(153, 153, 153, 0.5);
    }
    .touch_like{
      margin-top: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .touch_wrap{
        display: flex;
        align-items: center;
        div{
          margin-right: 0.06rem;
          img{
            display:block;
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 50%;
            // object-fit: cover;
          }
        }
        p{
          margin-left: 0.08rem;
          font-size: 0.22rem;
          color: #666;
        }
      }
      .like{
        height: 0.4rem;
        font-size: 0.22rem;
        color: #666;
        .iconfont{
          display: inline-block;
          transform: scale(1.1);
          margin-left:0.06rem;
          color: #fe781d;
        }
      }
    }
    .card_btn{
      display: flex;
      margin-top: 0.53rem;
      align-items: center;
      margin-left: -0.3rem;
      .share{
        width: 0.54rem;
        height: 0.74rem;
        background: #fff;
        box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
        position: relative;
        display: flex;
        .iconfont{
          position: absolute;
          z-index: 2;
          color: #fe781d;
          font-size: 0.36rem;
          top: 50%;
          transform: translateY(-50%);
          right: -0.18rem;
        }
        p{
          font-size: 0.2rem;
          width: 100%;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          padding: 0.22rem;
          color: #666;
          position: relative;
          z-index: 1;
        }
        .icon_ban{
          position: absolute;
          right: -0.2rem;
          top: 50%;
          transform: translateY(-50%);
          width: 0.5rem;
          height: 0.5rem;
          background: #fff;
          box-shadow:0px 3px 8px 0px rgba(0, 0, 0, 0.2);
          border-radius:50%;
        }
      }
      .btn{
        height: 0.74rem;
        width: 2.9rem;
        text-align: center;
        line-height: 0.74rem;
        font-size: 0.3rem;
        color: #762d06;
        border-radius: 0.04rem;
        &.video{
          margin-left: 0.48rem;
          background-image: linear-gradient(90deg, #f3a97f 0%, #ffd0b1 100%),
        }
        &.consult{
          margin-left: 0.3rem;
          line-height: 0.7rem;
          border: 1px solid #762d06;
        }
      }
    }
  }
  .service_comp{
    margin-top: 0.3rem;
    width: 100%;
    padding: 0.3rem;
    background: #fff;
    display: flex;
    img{
      flex-shrink: 0;
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.24rem;
      border-radius: 50%;
      border: 1px solid #e6e6e6;
      // object-fit: cover;
    }
    .comp_info{
      width: calc(100% - 1.44rem);
      p{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .copm_top{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p{
          font-size: 0.3rem;
          color: #333;
          font-weight: bold;
        }
        span{
          flex-shrink: 0;
          font-size: 0.26rem;
          color: #666;
          .iconfont{
            font-size: 0.32rem;
            display: inline-block;
            transform: rotate(-90deg) scale(1.2);
          }
        }
      }
      .confirm_jion{
        font-size: 0.22rem;
        color: #999;
        margin-top: 0.1rem;
        span{
          font-size: 0.22rem;
          color: #666;
        }
      }
      .site_tag{
        margin-top: 0.08rem;
        display: flex;
        align-items: center;
        margin-left: -0.06rem;
        color: #666;
        p{
          .iconfont{
            vertical-align:middle;
            color: #1890ff;
          }
         &:first-child{
           flex-shrink: 0;
           margin-right: 0.2rem;
           .iconfont{
             color: #fe781d;
           }
         }
        }
      }
      .total{
        display: flex;
        margin-top: 0.18rem;
        div{
          height: 0.36rem;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 0.12rem;
          background: #f2f2f2;
          color: #333;
          font-size: 0.22rem;
          margin-right: 0.2rem;
          :last-child{
            margin-right: 0;
          }
          span{
            color:#ff5c00;
            font-size: 0.22rem;
          }
        }
      }
    }
  }
}
</style>
